import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";

// Modals
import APIScreen from "./APIScreen";
import APIVarification from "./APIScreen/elements/APIVarification";
import APICreateForm from "./APIScreen/elements/APICreateForm";

const BreadcumpIcon = `${EASYCOMMERCE.assets}admin/img/icons/breadcump.png`;
const rightDivider = `${EASYCOMMERCE.assets}admin/img/icons/header-right.png`;
const userIcon = `${EASYCOMMERCE.assets}admin/img/icons/header-default-user-icon.png`;
const logo = `${EASYCOMMERCE.assets}common/img/logo.svg`;

const profileIcon = `${EASYCOMMERCE.assets}admin/img/icons/profile-icon.png`;
const disconnectIcon = `${EASYCOMMERCE.assets}admin/img/icons/disconnect-icon.png`;

const CommonHeader = ({
    parentSlug,
    parentLavel = "EasyCommerce",
    breadcumpSlug,
    isSettings = false,
    children,
}) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showAPIModal, setShowAPIModal] = useState(false);
    const [currentAPIModalTab, setCurrentAPIModalTab] = useState("");

    const handleModalClose = () => {
        setShowAPIModal(false);
        setCurrentAPIModalTab("");
    };

    const handleDisconnect = () => {
        easycommerce_modal(true);

        fetch(`${EASYCOMMERCE.rest_base}/connectivity/disconnect`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success && !data.data?.connected) {
                    const cookies = new Cookies(null, { path: "/" });
                    cookies.remove("easy-user", { path: "/" });

                    window.location.reload();
                }

                easycommerce_modal(false);
            });
    };

    useEffect(() => {
        // Check if user is connected
        const cookies = new Cookies(null, { path: "/" });
        const easyUser = cookies.get("easy-user");

        if (!easyUser) {
            fetch(`${EASYCOMMERCE.rest_base}/connectivity/check`,{
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": EASYCOMMERCE.nonce,
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success && data.data.connected) {
                        setUser(data.data.user);

                        cookies.set(
                            "easy-user",
                            JSON.stringify(data.data.user),
                            { path: "/", maxAge: 86400 * 30 }
                        );
                    }

                    setIsLoading(false);
                });
        } else {
            setUser(easyUser);
            setIsLoading(false);
        }
    }, []);

    return (
        <>
            {showAPIModal && currentAPIModalTab === "" ? (
                <APIScreen
                    onClose={handleModalClose}
                    switchVariationModalTab={() =>
                        setCurrentAPIModalTab("apiVarification")
                    }
                    switchCreateModalTab={() =>
                        setCurrentAPIModalTab("apiCreate")
                    }
                />
            ) : showAPIModal && currentAPIModalTab === "apiVarification" ? (
                <APIVarification
                    onClose={handleModalClose}
                    switchModalTab={() => setCurrentAPIModalTab("apiCreate")}
                    setUserAfterVarification={(userData) => setUser(userData)}
                />
            ) : showAPIModal && currentAPIModalTab === "apiCreate" ? (
                <APICreateForm
                    onClose={handleModalClose}
                    isSettings={isSettings}
                    switchModalTab={() =>
                        setCurrentAPIModalTab("apiVarification")
                    }
                />
            ) : null}

            <div className="relative bg-[#FFFFFF] py-6 px-12 flex justify-between items-center">
                <div className="flex items-center gap-8">
                    <img
                        src={logo}
                        alt="breadcump-icon"
                        className="pointer-events-none"
                    />

                    <div className="flex items-center gap-3">
                        <img
                            src={BreadcumpIcon}
                            alt="breadcump-icon"
                            className="w-4 h-4 pointer-events-none"
                        />

                        <h3>
                            <a
                                className="text-sm leading-5 font-medium text-ec-placeholder 
								hover:text-ec-primary focus:text-ec-primary active:text-ec-primary
								focus:shadow-none active:shadow-none focus:outline-none"
                                href={`?page=${parentSlug.toLowerCase()}`}
                            >
                                {parentLavel}
                            </a>
                        </h3>
                        {isSettings && (
                            <>
                                <img
                                    src={rightDivider}
                                    alt="divider-icon"
                                    className="w-3 h-3 pointer-events-none"
                                />

                                <h3>
                                    <a
                                        className="text-sm leading-5 font-medium text-ec-placeholder hover:text-ec-primary"
                                        href="?page=easycommerce-settings"
                                    >
                                        Settings
                                    </a>
                                </h3>
                            </>
                        )}
                        <img
                            src={rightDivider}
                            alt="divider-icon"
                            className="w-3 h-3 pointer-events-none"
                        />

                        <h3 className="text-sm leading-5 font-medium text-ec-primary">
                            {breadcumpSlug}
                        </h3>
                    </div>
                </div>
                <div className="relative flex justify-end items-center gap-1">
                    {children}

                    {!isLoading && (
                        <div className="relative group">
                            <button
                                className="w-12 h-12 flex justify-center items-center border border-ec-border rounded-md"
                                onClick={
                                    !user
                                        ? () => setShowAPIModal(!showAPIModal)
                                        : () => {}
                                }
                            >
                                <img
                                    src={!user ? userIcon : user?.photo}
                                    alt="user-icon"
                                    className="pointer-events-none rounded"
                                    style={{
                                        width: user ? "38px" : "24px",
                                        height: user ? "38px" : "28px",
                                    }}
                                />
                            </button>

                            {user && (
                                <div className="absolute pt-3 right-0 z-10 group-hover:block hidden">
                                    <div
                                        className="w-[220px] flex flex-col gap-3 bg-white p-4 border border-ec-border rounded-xl"
                                        style={{
                                            boxShadow:
                                                "0px 30px 34px -2px #0000001F",
                                        }}
                                    >
                                        <a
                                            href="https://my.easycommerce.dev/dashboard/"
                                            className="w-full flex justify-start items-center gap-3 px-4 py-3 
                                            rounded-md hover:bg-[#F8F8F8] focus:shadow-none focus:outline-none active:shadow-none"
                                        >
                                            <img
                                                src={profileIcon}
                                                className="w-[14px] h-4"
                                            />
                                            <span className="text-base leading-[26px] font-inter font-normal text-ec-body">
                                                Profile
                                            </span>
                                        </a>

                                        <button
                                            className="w-full flex justify-start items-center gap-3 px-4 py-3 
                                            rounded-md hover:bg-[#F8F8F8]"
                                            onClick={() => handleDisconnect()}
                                        >
                                            <img
                                                src={disconnectIcon}
                                                className="w-5 h-4"
                                            />
                                            <span className="text-base leading-[26px] font-inter font-normal text-ec-body">
                                                Disconnect
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default CommonHeader;
